<template>
  <b-container class="p-3" fluid>
    <loading-spinner v-if="isLoading" text="กำลังโหลด..." />
    <b-row v-else>
      <b-col>
        <b-card no-body>
          <h6 slot="header" class="mb-0">
            <font-awesome-icon icon="history" />ประวัติและความเห็นการพิจารณาโครงการ
          </h6>

          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th class="text-center" width="50">#</th>
                <th class="text-center" width="200">วันที่/เวลา</th>
                <th width="400">การกระทำ</th>
                <th>ผู้กระทำ</th>
                <th>เหตุผล/ความเห็น</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!changes.length">
                <td colspan="5" class="text-center text-muted py-4">ไม่มีข้อมูล</td>
              </tr>
              <tr v-for="(change, index) in changes" :key="index">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ change.createdAt }}</td>
                <td>
                  <strong>{{ change.type | changeTypeEnumToText }}</strong>
                  <div class="change-detail">
                    <template v-if="change.type === 'Status'">
                      <small>
                        {{ PROJECT_STATUS_TEXT[change.prevStatus] }}
                        <font-awesome-icon icon="arrow-right" class="mx-1" style="font-size: 0.65rem;" />
                        {{ PROJECT_STATUS_TEXT[change.currentStatus] }}
                      </small>
                    </template>
                  </div>
                </td>
                <td>
                  {{ change.user.thFullName }}<br>
                  <small>{{ USER_ROLE_TEXT[change.user.role] }}</small>
                </td>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <td v-html="change.comment" />
              </tr>
            </tbody>
          </table>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { PROJECT_STATUS_TEXT, USER_ROLE_TEXT } from '@/constants'
import LoadingSpinner from '@/components/layouts/LoadingSpinner'

export default {
  components: {
    LoadingSpinner
  },
  filters: {
    changeTypeEnumToText (value) {
      switch (value) {
        case 'Status':
          return 'เปลี่ยนแปลงสถานะ'
      }
    }
  },
  data: () => ({
    isLoading: true,
    changes: [],
    PROJECT_STATUS_TEXT,
    USER_ROLE_TEXT
  }),
  created () {
    this.$store.dispatch('project/loadChangeHistory', this.$route.params.id).then(() => {
      this.changes = this.$store.getters['project/getProject'](this.$route.params.id).changeHistory
      this.isLoading = false
    })
  }
}
</script>

<style lang="scss" scoped>
small {
  font-size: 88%;
}
</style>
